import { useMemo, useState } from 'react';
import { Link as FluentLink } from '@fluentui/react-components';

import { ItemList, TDisplayItem } from '@shared/components';
import { buildHref } from '@shared/utils';
import { TDocument } from '@modules/documents';
import { TInlineBlock } from '@modules/inlineBlocks';
import { TResolvedItemsMap } from '../../../types/items.types';

type TProps = {
  block: TDocument | TInlineBlock;
  resolvedItems: TResolvedItemsMap;
};

const BlockCompleteWarning = ({ block, resolvedItems }: TProps) => {
  const [itemsWithDraft, itemsWithoutDraft] = useMemo(() => {
    const withDraft: TDisplayItem[] = [];
    const withoutDraft: TDisplayItem[] = [];
    block.placementsOfBlock
      .filter((placedBlock) => placedBlock.versionMode === 'AUTO' && resolvedItems[placedBlock.doc])
      .forEach((placedBlock) => {
        const resolvedItem = resolvedItems[placedBlock.doc];
        const displayItem: TDisplayItem = {
          id: placedBlock.id,
          duplicateId: placedBlock.doc,
          text: resolvedItem.item.name,
          href: buildHref(`/document/${placedBlock.doc}`, { view: 'latest', elem: placedBlock.id }),
        };
        if (resolvedItem.item.hasDraft) withDraft.push(displayItem);
        else withoutDraft.push(displayItem);
      });
    return [withDraft, withoutDraft];
  }, [block.placementsOfBlock, resolvedItems]);

  const numItemsWithDraft = Array.from(new Set(itemsWithDraft.map((i) => i.duplicateId))).length;
  const numItemsWithoutDraft = Array.from(new Set(itemsWithoutDraft.map((i) => i.duplicateId))).length;

  const [showWithDraft, setShowWithDraft] = useState(false);
  const [showWithoutDraft, setShowWithoutDraft] = useState(false);

  return (
    <div>
      {itemsWithoutDraft.length > 0 && (
        <div>
          <div className="flex space-x-2 mb-2">
            {numItemsWithoutDraft === 1 ? (
              <p className="font-bold">A new draft will be created for 1 document:</p>
            ) : (
              <p className="font-bold">New drafts will be created for {numItemsWithoutDraft} documents:</p>
            )}
            <FluentLink onClick={() => setShowWithoutDraft(!showWithoutDraft)}>
              {showWithoutDraft ? 'Hide' : 'Show'}
            </FluentLink>
          </div>
          {showWithoutDraft && <ItemList displayItems={itemsWithoutDraft} isSideBar={false} />}
        </div>
      )}
      {numItemsWithDraft > 0 && (
        <div>
          <div className="flex space-x-2 mb-2">
            <p className="font-bold">
              The draft of {numItemsWithDraft} document{numItemsWithDraft === 1 ? '' : 's'} will be updated:
            </p>
            <FluentLink onClick={() => setShowWithDraft(!showWithDraft)}>{showWithDraft ? 'Hide' : 'Show'}</FluentLink>
          </div>
          {showWithDraft && <ItemList displayItems={itemsWithDraft} isSideBar={false} />}
        </div>
      )}
    </div>
  );
};

export default BlockCompleteWarning;
